"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var Container_1 = __importDefault(require("@mui/material/Container"));
var react_1 = __importStar(require("react"));
var ScrollContainerHelpers_1 = require("./ScrollContainerHelpers");
var makeScrollContainerStyling_1 = __importStar(require("./makeScrollContainerStyling"));
/**
 * ScrollContainer
 *
 * @param maxWidth number
 * @returns children with two additional props, onContentMounting and onContentMounted
 *
 * There are four conditions for scrolling, from a page which needs | notNeeds to a page that needs | notNeeds a scroll area.
 */
var ScrollContainer = function (_a) {
    var children = _a.children, maxWidth = _a.maxWidth;
    var childRef = (0, react_1.useRef)(null);
    var _b = (0, react_1.useState)(false), skipAllScrollUpdates = _b[0], setSkipAllScrollUpdates = _b[1];
    var _c = (0, react_1.useState)(null), scrollDetails = _c[0], setScrollDetails = _c[1];
    var _d = (0, react_1.useState)(false), isContentUpdated = _d[0], setContentUpdated = _d[1];
    var isScrollNeeded = scrollDetails !== null;
    var scrollBufferOffset = (0, ScrollContainerHelpers_1.getScrollBufferOffset)(scrollDetails);
    var scrollBufferOpacity = (0, ScrollContainerHelpers_1.getScrollBufferOpacity)(scrollDetails);
    var styles = (0, makeScrollContainerStyling_1.default)({
        scrollBufferOffset: scrollBufferOffset,
        scrollBufferOpacity: scrollBufferOpacity,
    });
    var getScrollDetailsOrNull = function () {
        var element = childRef.current;
        var scrollHeight = (element === null || element === void 0 ? void 0 : element.scrollHeight) || 0;
        var adjustedScrollHeight = scrollHeight;
        var scrollBuffer = document.querySelector('[data-testid="scrollBuffer"]');
        if (scrollBuffer && scrollHeight) {
            /**
             * if the page has a scroll buffer there is an unknown 4px which needs to be considered with the buffer height
             */
            adjustedScrollHeight = scrollHeight - makeScrollContainerStyling_1.SCROLL_BUFFER_HEIGHT - 4;
        }
        if (!element ||
            adjustedScrollHeight <= element.clientHeight ||
            element.clientHeight === 0) {
            return null;
        }
        return {
            scrollHeight: element.scrollHeight,
            clientHeight: element.clientHeight,
            offsetTop: element.offsetTop,
            scrollTop: element.scrollTop,
        };
    };
    var toggleScrollBuffer = function () {
        if (!skipAllScrollUpdates) {
            setScrollDetails(getScrollDetailsOrNull());
        }
    };
    (0, react_1.useEffect)(function () {
        toggleScrollBuffer();
        if (isContentUpdated) {
            setContentUpdated(false);
        }
        return function () {
            // TODO intention here is to set scroll needed as false, not to set the scroll details to null - refactor? Wasting a render cycle here
            setScrollDetails(null);
        };
        // TODO isScrollNeeded - setting scroll details should be dependent on a change in clientHeight / scrollHeight, so they should be the arguments to this useEffect
    }, [children, isScrollNeeded, isContentUpdated]);
    (0, react_1.useEffect)(function () {
        window.addEventListener('resize', function () { return toggleScrollBuffer(); });
        return function () {
            window.removeEventListener('resize', function () { return toggleScrollBuffer(); });
        };
    }, []);
    var updatedChildren = react_1.default.cloneElement(children, {
        /**
         * This provides a new prop to the children of the ScrollArea, called onContentMounted, that is a function that can and should be called once the children have mounted.
         *
         * Calling onContentMounted is required by a child to ensure that the state of the scroll area is kept up to date.
         */
        onContentMounted: function () {
            setSkipAllScrollUpdates(false);
            setContentUpdated(true);
        },
        /**
         * There is a race condition on mounting of the component, we only want to allow an update of the content after the mounting has completed
         */
        onContentMounting: function () { return setSkipAllScrollUpdates(true); },
    });
    return ((0, jsx_runtime_1.jsxs)("div", { css: styles.scrollBox, ref: childRef, onScroll: toggleScrollBuffer, children: [(0, jsx_runtime_1.jsxs)(Container_1.default, { maxWidth: maxWidth, children: [updatedChildren, isScrollNeeded && (0, jsx_runtime_1.jsx)("div", { css: styles.scrollPadding })] }), isScrollNeeded && ((0, jsx_runtime_1.jsx)("div", { css: styles.scrollBuffer, "data-testid": "scrollBuffer" }))] }));
};
exports.default = ScrollContainer;
//# sourceMappingURL=ScrollContainer.js.map